var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{style:({ maxWidth: '120px' }),attrs:{"items":_vm.itemsWithValue,"item-text":_vm.itemText,"item-value":_vm.itemValue,"value":_vm.internalValue,"label":_vm.label},on:{"input":_vm.onInput,"change":_vm.onUserChange}},[_vm._v(" "+_vm._s(_vm.chipDisplayText)+" "),_c('v-icon',{attrs:{"right":"","small":""}},[_vm._v("mdi-chevron-down")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }